/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:logoutEventUtility
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/17 | 富士通株式会社         | 新規作成
// 01.01.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
 */
import store from '@/store/store.js';
import { co_postLogout } from '@/common/ajaxUtility.js';

import { PATH_LOGOUT } from '@/const/route.js';
import { STORE_USER_CLEAR, STORE_USER_IS_AUTHENTICATED, STORE_ERROR_CLEAR,
			STORE_DATA_DELETE_ALL, STORE_VIEW_CLEAR_PAGE, STORE_VIEW_CLEAR_VIEW_PARAMS } from '@/const/store.js';

/*
 * ログアウト処理を実行する
 */
export function co_doLogout() {

	// 認証済みの場合のみログアウト処理を実行する
	if (store.getters[STORE_USER_IS_AUTHENTICATED]) {
		// エラークリア
		store.commit(STORE_ERROR_CLEAR);

		// ログアウト処理実行する
		co_postLogout(PATH_LOGOUT);

		// 画面保持情報クリア
		store.commit(STORE_DATA_DELETE_ALL);
		store.commit(STORE_VIEW_CLEAR_PAGE);
		store.commit(STORE_VIEW_CLEAR_VIEW_PARAMS);

		// ストア（ユーザ情報）削除
		store.commit(STORE_USER_CLEAR);

	}

}